<template>
  <div v-if="profitloss && balance" class="ratio-item">
    <div class="items-title"> {{ title }}</div>
    <div class="value">{{ value }}</div>
  </div>
</template>

<script>
// tslint:disable:max-line-length
export default {
  props: {
    financialItem: String,
    profitloss: Object,
    balance: Object,
    cashflow: Object,
  },

 computed: {
   value() {
     switch (this.financialItem) {
       case 'growth':
           return this.$options.filters.P(((this.profitloss.sheets[0].A * ( 12 / this.profitloss.sheets[0].MONTHS)) / (this.profitloss.sheets[1].A * ( 12 / this.profitloss.sheets[1].MONTHS))) - 1);
       case 'turnover':
         return this.$options.filters.KRP(this.profitloss.sheets[0].A );
       case 'operatingResult':
         return this.$options.filters.KRP(this.profitloss.sheets[0].K);
       case 'operatingMargin':
         return this.$options.filters.P((this.profitloss.sheets[0].K / this.profitloss.sheets[0].A));
       case 'yearResult':
         return this.$options.filters.KRP(this.profitloss.sheets[0].R);
       case 'grossMargin':
         return this.$options.filters.P((this.profitloss.sheets[0].A + this.profitloss.sheets[0].D) / this.profitloss.sheets[0].A);
       case 'valueAdded':
         return this.$options.filters.P((this.profitloss.sheets[0].K - this.profitloss.sheets[0].J - this.profitloss.sheets[0].G) / this.profitloss.sheets[0].A);
       case 'returnOnEquity':
         return this.$options.filters.P(this.profitloss.sheets[0].N / ( this.balance.sheets[0].M + ( 0.794 * this.balance.sheets[0].N )));
       case 'returnOnCapital':
         return this.$options.filters.P(this.profitloss.sheets[0].K / this.balance.sheets[0].S );
       case 'totalAssets':
         return this.$options.filters.KRP(this.balance.sheets[0].L );
       case 'solidity':
         return this.$options.filters.P((this.balance.sheets[0].M + ( 0.794 * this.balance.sheets[0].N )) / this.balance.sheets[0].L );
       case 'quickRatio':
         return this.$options.filters.P((this.balance.sheets[0].K - this.balance.sheets[0].F ) / this.balance.sheets[0].Q );
       case 'totalEquity':
         return this.$options.filters.KRP(this.balance.sheets[0].M );
       case 'netMargin':
         return this.$options.filters.P(this.profitloss.sheets[0].R / this.profitloss.sheets[0].A );
       case 'totalCashflow':
         return this.$options.filters.KRP(this.cashflow.sheets[0].CashFlow );
       case 'operatingCashflow':
         return this.$options.filters.KRP(this.cashflow.sheets[0].OperatingCashflow );
       case 'operatingCashflowPercent':
         return this.$options.filters.P(this.cashflow.sheets[0].OperatingCashflow / this.profitloss.sheets[0].A);
       case 'cash':
         return this.$options.filters.KRP(this.balance.sheets[0].J);
       case 'workingCapital':
         return this.$options.filters.KRP(this.balance.sheets[0].K - this.balance.sheets[0].J - this.balance.sheets[0].Q + this.balance.sheets[0].U);
       case 'workingCapitalPercent':
         return this.$options.filters.P((this.balance.sheets[0].K - this.balance.sheets[0].J - this.balance.sheets[0].Q + this.balance.sheets[0].U) / this.profitloss.sheets[0].A );
     }
   },
   title() {
     switch (this.financialItem) {
       case 'growth':
           return 'Nettoomsättningstillväxt';
       case 'turnover':
         return 'Nettoomsättning';
       case 'operatingMargin':
         return 'Rörelsemarginal';
       case 'yearResult':
         return 'Årets resultat';
       case 'grossMargin':
         return 'Bruttomarginal';
       case 'valueAdded':
         return 'Förädlingsgrad';
       case 'returnOnEquity':
         return 'Avkastning på eget kapital';
       case 'returnOnCapital':
         return 'Avkastning på totalt kapital';
       case 'totalAssets':
         return 'Balansomslutning';
       case 'solidity':
         return 'Soliditet';
       case 'quickRatio':
         return 'Kassalikviditet';
       case 'totalEquity':
         return 'Eget kapital';
       case 'netMargin':
         return 'Nettomarginal';
       case 'totalCashflow':
         return 'Årets totala kassaflöde';
       case 'operatingCashflow':
         return 'Operativt kassaflöde';
       case 'operatingCashflowPercent':
         return 'i % av nettoomsättning';
       case 'cash':
         return 'Kassa & bank';
       case 'workingCapital':
         return 'Bindning i rörelsekapital (exkl. kassa & bank)';
       case 'workingCapitalPercent':
         return 'i % av nettoomsättning';
       case 'operatingResult':
         return 'Rörelseresultat';
     }
   },
 },
};

</script>

<style lang="scss" scoped>
  .ratio-item {
    background-color: col("colors.Light");
    flex: 1 0 100%;
    padding: 1rem;
    text-align: center;
    border-radius: 0.2rem;
    border: 1px solid col("colors.LightGrey");
    transition: 0.5s;
    &:hover {
      box-shadow: inset 0 0 0 0.2rem col("colors.Secondary");
      cursor: pointer;
    }
  }

  .items-title {
    font-size: 1rem;
    text-transform: uppercase;
  }

  .value {
    font-weight: 600;
  }

  .active {
    background-color: col("colors.Secondary");
    color: col("colors.White");
    border-color: col("colors.Black");
  }

</style>
